export default "__VITE_ASSET__BdIfPpva__"